import Vue from "vue";
import VueMeta from "vue-meta";
import store from "./store";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import axios from "axios";
import { createClient } from "contentful";
import VueClipboard from "vue-clipboard2";

// router setup
import router from "./routes/router";
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(VueClipboard);

// Contentful
Vue.prototype.$contentful = createClient({
  space: "lgkefo7weyfl",
  accessToken: "MsjE3kxTfq0Eqr8-3CPWilx6cSJ_5glEZBYFsLUWitQ"
});

// Authentication
const token = localStorage.getItem("user-token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "bearer " + token;
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store
});
